const size = {
  mobile: '480px',
  desktop: '1440px',
};

export const device = {
  mobile: `(max-width: ${size.mobile})`,
  desktop: `(max-width: ${size.desktop})`,
};
